/**
 * ActivityAuditIcon — Mi6 custom glyph: checklist with fingerprint arc
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function ActivityAuditIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Clipboard body */}
      <rect x="18" y="18" width="36" height="46" rx="3" stroke="currentColor" strokeWidth="1.5" />
      {/* Clipboard top clip */}
      <rect x="28" y="14" width="16" height="8" rx="2" stroke="currentColor" strokeWidth="1.5" />
      {/* Checklist rows */}
      <line x1="26" y1="32" x2="34" y2="32" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="24,31 27,34 32,28" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <line x1="26" y1="42" x2="34" y2="42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="24,41 27,44 32,38" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <line x1="26" y1="52" x2="34" y2="52" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Fingerprint arcs bottom-right overlay */}
      <path d="M50 52 C50 46 56 46 56 52" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <path d="M47 56 C47 47 59 47 59 56" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <path d="M44 60 C44 48 62 48 62 60" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <path d="M53 63 C53 60 53 57 53 54" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}
